import React from "react";
import Select from "react-select";
import { elm } from "../common/helpers/colors";

const selectStyle = {
  container: (base) => ({
    ...base,
    width: "500px",
    display: "inline-block",
    position: "relative",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0px",
    position: "relative",
    marginTop: "-1px",
    border: "1px solid #216d6e",
  }),
  control: (base, state) => ({
    ...base,
    borderRadius: "0px",
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: state.isFocused ? elm : base.borderColor,
    "&:hover": {
      borderColor: state.isFocused ? elm : base.borderColor,
    },
  }),
};

const VarsomeSelect = (props) => {
  return <Select styles={selectStyle} {...props} />;
};

export default VarsomeSelect;
